import axios from "axios";
import queryString from "query-string";

const authApi = {
	login: params =>
		axios.post(
			"http://preview6599.canhcam.com.vn/connect/token",
			queryString.stringify({
				...params,
				grant_type: "password",
				client_id: "ro.client",
				client_secret: "secret",
			}),
			{
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
				},
			}
		),
	verifyToken: () => axios.post("http://preview6599.canhcam.com.vn/"),
};
export default authApi;
